export const ColumnHeader = ({ children }: { children: React.ReactNode }) => (
  <span className="text-xs font-bold text-quaternary-500">{children}</span>
)

export const CellText = ({ children }: { children: React.ReactNode }) => (
  <span
    className="text-sm text-foreground-fg-primary"
    style={{ letterSpacing: children === '--' ? '-0.15em' : undefined }}
  >
    {children}
  </span>
)

export const CellTextMedium = ({ children }: { children: React.ReactNode }) => (
  <span className="font-medium text-foreground-fg-primary">{children}</span>
)
